import { CLOSE_INVOICE_PREVIEW } from "../constants";

export const closeInvoicePreview = () =>
  ({
    type: CLOSE_INVOICE_PREVIEW
  } as const);
